import { useSyncExternalStore } from 'react';

/**
 * 뷰포트가 `minWidth` 이상인지 — `matchMedia` 구독(`useSyncExternalStore` 로 effect-setState 없이).
 *
 * **`useIsCompact` 와 구분해서 쓴다.** 저건 앱 전역 프레젠테이션 경계(`< lg` 1024 — 필터 셸·네비·뷰 전환)라
 * 값이 합의된 상수다. 여기 필요한 건 그것과 **다른 축**의 판단(예: "표에 고정 열을 걸 만큼 폭이 있는가")이라,
 * 전역 경계를 끌어다 쓰면 한쪽 요구로 다른 쪽이 흔들린다. 소비처가 자기 기준 폭을 직접 준다.
 */
export function useMinWidth(minWidth: number): boolean {
  const query = `(min-width: ${minWidth}px)`;
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
